import { supabase } from './supabaseClient';

export async function uploadFileToSupabase(file: File, userId: string) {
  // Sanitize the file name to remove special characters that might cause issues
  const sanitizedFileName = file.name
    .replace(/[^a-zA-Z0-9.-]/g, '_') // Replace special chars with underscore
    .replace(/_{2,}/g, '_') // Replace multiple underscores with single
    .replace(/^_|_$/g, ''); // Remove leading/trailing underscores
  
  const filePath = `${userId}/${Date.now()}-${sanitizedFileName}`;
  
  console.log('Uploading file:', {
    originalName: file.name,
    sanitizedName: sanitizedFileName,
    filePath,
    fileSize: file.size,
    fileType: file.type
  });

  const { error } = await supabase.storage
    .from('files')
    .upload(filePath, file, {
      contentType: file.type,
      upsert: false // Don't overwrite existing files
    });

  if (error) {
    console.error('File upload error:', error);
    throw new Error(`File upload failed: ${error.message}`);
  }

  const { data } = supabase.storage.from('files').getPublicUrl(filePath);
  const publicUrl = data.publicUrl;
  
  console.log('File uploaded successfully:', {
    filePath,
    publicUrl
  });
  
  return publicUrl;
} 